function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.459297 2.08873C3.47871 4.64585 8.77684 9.14459 10.334 10.5473C10.5431 10.7366 10.7673 10.8329 11 10.8329C11.2323 10.8329 11.4562 10.7375 11.6647 10.5491C13.2232 9.14502 18.5214 4.64585 21.5408 2.08873C21.7288 1.92984 21.7575 1.65054 21.6053 1.45628C21.2535 1.00738 20.7289 0.75 20.1667 0.75H1.83339C1.27123 0.75 0.746629 1.00738 0.394844 1.45632C0.242649 1.65054 0.271309 1.92984 0.459297 2.08873Z",
  fill: "current"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7342 3.47449C21.5717 3.39887 21.3806 3.42525 21.2454 3.54075C17.8969 6.37935 13.6233 10.0179 12.2788 11.2295C11.5241 11.9107 10.4767 11.9107 9.7203 11.2285C8.28712 9.93725 3.48803 5.85745 0.754617 3.54071C0.618535 3.42521 0.42698 3.39973 0.265848 3.47445C0.103855 3.54969 0 3.71172 0 3.8903V15.4167C0 16.4278 0.822207 17.25 1.83335 17.25H20.1667C21.1778 17.25 22 16.4278 22 15.4167V3.8903C22 3.71172 21.8961 3.54926 21.7342 3.47449Z",
  fill: "current"
});

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.f208a878.svg";
export { ForwardRef as ReactComponent };